import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ApiCalling from "../../ApiServices/ApiCalling";

const LoginService = () => {

  const [input, setInput] = useState({});
  const [inputOtp, setInputOtp] = useState({});
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [validationOTPErrors, setValidationOTPErrors] = useState({});
  const [getOtpGenData, setOtpGenData] = useState({});
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isOtpRequired, setIsOtpRequired] = useState(false);
  const [otpSessionPsw, setOtpSessionPsw] = useState("");

  // ⭐ NEW STATES
  const [isSignupFlow, setIsSignupFlow] = useState(false);
  const [signupSession, setSignupSession] = useState("");

  const togglePassword = () => setShowPassword((prev) => !prev);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        () => {}
      );
    }
  }, []);

  const handleChangeOTP = (e) => {
    const { name, value } = e.target;
    setInputOtp((prev) => ({ ...prev, [name]: value }));
  };

  const validateFormOTP = () => {
    const errors = {};
    if (!inputOtp?.UserID) errors.UserID = "Mobile required";
    setValidationOTPErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ================= GENERATE OTP =================

  const generateOtp = async () => {

    if (!validateFormOTP()) return;

    const loginRes = await ApiCalling.request(
      "POST",
      "/LoginWithOTPAsync",
      {
        LoginTypeID: 1,
        UserID: inputOtp?.UserID,
        Latitude: location.latitude,
        Longitude: location.longitude,
      },
      null
    );

    // ⭐ REGISTERED USER
    if (loginRes?.statuscode === 2) {
      setOtpGenData(loginRes?.otpSession);
      setIsOtpGenerated(true);
      setIsSignupFlow(false);
      toast.success("OTP sent for login");
      return;
    }

    // ⭐ NOT REGISTERED → SIGNUP FLOW
    const signupRes = await ApiCalling.request(
      "POST",
      "/SignUpWithOTP",
      {
        loginTypeID: 1,
        userID: inputOtp?.UserID,
        Latitude: location.latitude,
        Longitude: location.longitude,
      },
      null
    );

    if (signupRes?.statuscode === 2) {
      setSignupSession(signupRes?.otpSession);
      setIsOtpGenerated(true);
      setIsSignupFlow(true);
      toast.success("OTP sent for signup");
    } else {
      toast.error(signupRes?.msg);
    }
  };

  // ================= LOGIN WITH OTP =================

  const logInWithOtp = async (e) => {

    e.preventDefault();

    try {

      // 🔵 NORMAL LOGIN
      if (!isSignupFlow) {

        const res = await ApiCalling.request(
          "POST",
          "/ValidateOTP",
          {
            LoginTypeID: 1,
            OTP: otpValue,
            OTPSession: getOtpGenData,
          },
          null
        );

        if (res?.statuscode !== 1) {
          toast.error(res?.msg);
          return;
        }

        await handleSuccessfulLogin(res?.data, res?.msg);
      }

      // 🟠 SIGNUP VERIFY FLOW
      else {

        const signupVerify = await ApiCalling.request(
          "POST",
          "/SignUpWithOTP",
          {
            loginTypeID: 1,
            userID: inputOtp?.UserID,
            OTP: otpValue,
            Latitude: location.latitude,
            Longitude: location.longitude,
          },
          null
        );

        if (signupVerify?.statuscode !== 1) {
          toast.error(signupVerify?.msg);
          return;
        }

        toast.success("User registered successfully");

        // ⭐ DIRECT LOGIN CALL (NO OTP AGAIN)
        const loginAfterSignup = await ApiCalling.request(
          "POST",
          "/LoginWithOTPAsync",
          {
            LoginTypeID: 1,
            UserID: inputOtp?.UserID,
            Latitude: location.latitude,
            Longitude: location.longitude,
          },
          null
        );

        if (loginAfterSignup?.statuscode !== 1) {
          toast.error(loginAfterSignup?.msg || "Login failed after signup");
          return;
        }

        await handleSuccessfulLogin(
          loginAfterSignup?.data,
          loginAfterSignup?.msg
        );
      }

    } catch (err) {
      console.error(err);
    }
  };

  // ================= SUCCESS LOGIN COMMON =================

  const handleSuccessfulLogin = async (data, message) => {

    toast.success(message || "Login Success");

    sessionStorage.setItem("session", data?.session);
    sessionStorage.setItem("sessionID", data?.sessionID);
    sessionStorage.setItem("userID", data?.userID);
    sessionStorage.setItem("name", data?.name);
    sessionStorage.setItem("emailID", data?.emailID);
    sessionStorage.setItem("roleName", data?.roleName);
    sessionStorage.setItem("mobileNo", data?.mobileNo);

    try {
      const res = await ApiCalling.request("POST", "/GetOpTypes");

      if (res?.statuscode === 1) {

        const services = res?.data?.assignedOpTypes || [];

        const targetService = services.find(
          (service) => service.serviceID === 1
        );

        if (targetService) {

          const slugMap = {
            1: "recharge",
            11: "billpayment",
          };

          const slug =
            slugMap[targetService.serviceTypeID] || "otherservice";

          const path = `/${slug}/${targetService.name
            .replace(/\s+/g, "")
            .toLowerCase()}`;

          navigate(path);

        } else navigate("/");

      } else navigate("/");

    } catch {
      navigate("/");
    }
  };

  return {
    handleChangeOTP,
    inputOtp,
    generateOtp,
    logInWithOtp,
    validationOTPErrors,
    isOtpGenerated,
    otpValue,
    setOtpValue,
  };
};

export default LoginService;


//........ THIS FLOW CAN BE USED IN FUTURE SO DONT DELETE IT, FOR OTHER REPLICA PROJECT THIS MIGHT BE USED.........//

// import { useState, useEffect } from "react";
// import { toast } from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import ApiCalling from "../../ApiServices/ApiCalling";

// const LoginService = () => {
//   const [input, setInput] = useState({});
//   const [inputOtp, setInputOtp] = useState({});
//   const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [validationErrors, setValidationErrors] = useState({});
//   const [validationOTPErrors, setValidationOTPErrors] = useState({});
//   const [getOtpGenData, setOtpGenData] = useState({});
//   const [isOtpGenerated, setIsOtpGenerated] = useState(false);
//   const [otpValue, setOtpValue] = useState("");
//   const [isOtpRequired, setIsOtpRequired] = useState(false);
//   const [otpSessionPsw, setOtpSessionPsw] = useState("");

//   const togglePassword = () => setShowPassword((prev) => !prev);

//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setLocation({
//             latitude: position.coords.latitude,
//             longitude: position.coords.longitude,
//           });         
//         },
//         (error) => {
//           console.log("Location error:", error.message);
//           toast.error("Location access denied. Using default location.");          
//         }
//       );
//     } else {
//       toast.error("Geolocation is not supported by this browser.");
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setInput((prev) => {
//       return { ...prev, [name]: value };
//     });
//   };

//   const validateForm = (input, setValidationErrors) => {
//     const errors = {};

//     if (!input.UserID || input.UserID.trim() === "") {
//       errors.UserID = "UserId is required.";
//     }
//     if (!input.Password || input.Password.trim() === "") {
//       errors.Password = "Password is required.";
//     } else if (input.Password.length < 6) {
//       errors.Password = "Password must be at least 6 characters long.";
//     }

//     setValidationErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm(input, setValidationErrors)) {
//       return;
//     }

//     try {
//       if (!isOtpRequired) {
//         const bodyObject = {
//           LoginTypeID: 1,
//           UserID: input?.UserID,
//           Password: input?.Password,
//           Longitude: location?.longitude,
//           Latitude: location?.latitude,
//         };

//         const res = await ApiCalling.request(
//           "POST",
//           "/Login",
//           bodyObject,
//           null
//         );
//  if (res?.statuscode === 1) {
//           handleSuccessfulLogin(res?.data, res?.msg);
//         } else if (res?.statuscode === 2) {
//           setIsOtpRequired(true);
//           setOtpSessionPsw(res?.otpSession);
//           toast.success(res?.msg);
//         } else {
//           toast.error(res?.msg, { toastId: "login error" });
//         }
//       } else {
//         const bodyObject = {
//           LoginTypeID: 1,
//           OTP: input?.otp,
//           OTPSession: otpSessionPsw,
//         };

//         const res = await ApiCalling.request(
//           "POST",
//           "/ValidateOTP",
//           bodyObject,
//           null
//         );

//         if (res?.statuscode === 1) {
//           handleSuccessfulLogin(res?.data, res?.msg);
//         } else {
//           toast.error(res?.msg || "Invalid OTP", { toastId: "otp-error" });
//         }
//       }
//     } catch (error) {
//       console.error("Error during login:", error); 
//     }
//   };

//   const handleSuccessfulLogin = async (data, message) => {
//     toast.success(message, { toastId: "login success", autoClose: 700 });

//     sessionStorage.setItem("session", data?.session);
//     sessionStorage.setItem("sessionID", data?.sessionID);
//     sessionStorage.setItem("userID", data?.userID);
//     sessionStorage.setItem("name", data?.name);
//     sessionStorage.setItem("emailID", data?.emailID);
//     sessionStorage.setItem("roleName", data?.roleName);
//     sessionStorage.setItem("mobileNo", data?.mobileNo);

//     try {
//       const res = await ApiCalling.request("POST", "/GetOpTypes");
//       if (res?.statuscode === 1) {
//         const services = res?.data?.assignedOpTypes || [];

//         const targetService = services.find(
//           (service) => service.serviceID === 1
//         );

//         if (targetService) {
//           const serviceTypeSlugMap = {
//             1: "recharge",
//             11: "billpayment",
//           };

//           const slug =
//             serviceTypeSlugMap[targetService.serviceTypeID] || "otherservice";

//           const path = `/${slug}/${targetService.name
//             .replace(/\s+/g, "")
//             .toLowerCase()}`;

//           navigate(path);
//         } else {
//           navigate("/");
//         }
//       } else {
//         navigate("/");
//       }
//     } catch (err) {
//       console.error("Error fetching operator types for redirect", err);
//       navigate("/");
//     }
//   };

//   const handleChangeOTP = (e) => {
//     const { name, value } = e.target;
//     setInputOtp((prev) => {
//       return { ...prev, [name]: value };
//     });
//   };

//   const validateFormOTP = (inputOtp, setValidationOTPErrors) => {
//     const errors = {};

//     if (!inputOtp?.UserID || inputOtp?.UserID.trim() === "") {
//       errors.UserID = "UserId is required.";
//     } else if (!/^[6-9]\d{9}$/.test(inputOtp.UserID)) {
//       errors.UserID = "Enter a valid  mobile number.";
//     }
//     setValidationOTPErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const generateOtp = async (e) => {
//     if (!validateFormOTP(inputOtp, setValidationOTPErrors)) {
//       return;
//     }
//     e.preventDefault();
//     try {
//       const bodyObject = {
//         LoginTypeID: 1,
//         UserID: inputOtp?.UserID,
//         Longitude: location?.longitude,
//         Latitude: location?.latitude,
//       };

//       const res = await ApiCalling.request(
//         "POST",
//         "/LoginWithOTPAsync",
//         bodyObject,
//         null
//       );
//       if (res?.statuscode === 2) {
//         setOtpGenData(res?.otpSession);
//         setIsOtpGenerated(true);
//         toast.success("OTP has been sent to your number");
//       } else {
//         toast.error(res?.msg, { toastId: "LoginWithOTPAsync error" });
//       }
//     } catch (error) {
//       console.error("Error LoginWithOTPAsync in:", error);
//     }
//   };

//   const logInWithOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const bodyObject = {
//         LoginTypeID: 1,
//         OTP: otpValue,
//         OTPSession: getOtpGenData,
//       };
//       const res = await ApiCalling.request(
//         "POST",
//         "/ValidateOTP",
//         bodyObject,
//         null
//       );
//       if (res?.statuscode === 1) {
//         toast.success(res?.msg, { toastId: "login success", autoClose: 700 });
//         sessionStorage.setItem("session", res?.data?.session);
//         sessionStorage.setItem("sessionID", res?.data?.sessionID);
//         sessionStorage.setItem("userID", res?.data?.userID);
//         sessionStorage.setItem("name", res?.data?.name);
//         sessionStorage.setItem("emailID", res?.data?.emailID);
//         sessionStorage.setItem("roleName", res?.data?.roleName);
//         sessionStorage.setItem("mobileNo", res?.data?.mobileNo);

//         try {
//           const res = await ApiCalling.request("POST", "/GetOpTypes");
//           if (res?.statuscode === 1) {
//             const services = res?.data?.assignedOpTypes || [];

//             const targetService = services.find(
//               (service) => service.serviceID === 1
//             );

//             if (targetService) {
//               const serviceTypeSlugMap = {
//                 1: "recharge",
//                 11: "billpayment",
//               };

//               const slug =
//                 serviceTypeSlugMap[targetService.serviceTypeID] ||
//                 "otherservice";

//               const path = `/${slug}/${targetService.name
//                 .replace(/\s+/g, "")
//                 .toLowerCase()}`;

//               navigate(path);
//             } else {
//               navigate("/");
//             }
//           } else {
//             navigate("/");
//           }
//         } catch (err) {
//           console.error("Error fetching operator types for redirect", err);
//           navigate("/");
//         }
//       } else {
//         toast.error(res?.msg, { toastId: "logInWithOtp error" });
//       }
//     } catch (error) {
//       console.error("Error logInWithOtp in:", error);
//     }
//   };

//   return {
//     handleChange,
//     handleSubmit,
//     input,
//     showPassword,
//     togglePassword,
//     validationErrors,
//     handleChangeOTP,
//     inputOtp,
//     generateOtp,
//     validationOTPErrors,
//     logInWithOtp,
//     isOtpGenerated,
//     otpValue,
//     setOtpValue,
//     isOtpRequired,
//   };
// };

// export default LoginService;

